import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import {
  failureaddYearlevel_map,
  successaddYearlevel_map,
} from "./AddYearlevel_mapSlice";
import { PayloadAction } from "@reduxjs/toolkit";
import { IYearlevel_map } from "../../../Pages/Yearlevel_map/IYearlevel_map";

import {
  failuredeleteYearlevel_map,
  successdeleteYearlevel_map,
} from "./DeleteYearlevel_mapSlice";
import {
  failurelistYearlevel_map,
  successlistYearlevel_map,
} from "./ListYearlevel_mapSlice";
import {
  failureEditYearlevel_map,
  successEditYearlevel_map,
} from "./EditYearlevel_mapSlice";

// list
const ListYearlevel_mapApi = () => {
  return api.get("/api/category/yeargroup_region_mappings");
};

export function* ListYearlevel_mapCall() {
  try {
    const response: AxiosResponse = yield call(ListYearlevel_mapApi);
    yield put(successlistYearlevel_map(response.data));
  } catch (error) {
    yield put(failurelistYearlevel_map(error));
  }
}

// add
const AddYearlevel_mapApi = (action: PayloadAction<IYearlevel_map>) => {
  return api.post("/api/category/mapping", action.payload);
};

export function* AddYearlevel_mapCall(action: PayloadAction<IYearlevel_map>) {
  try {
    const response: AxiosResponse = yield call(AddYearlevel_mapApi, action);
    yield put(successaddYearlevel_map(response.data));
  } catch (error) {
    yield put(failureaddYearlevel_map(error));
  }
}

// edit
const EditYearlevel_mapApi = (action: PayloadAction<IYearlevel_map>) => {
  return api.put("/api/category/update_yeargroup_mapping", action.payload, {
    params: { id: action.payload.id },
  });
};

export function* EditYearlevel_mapCall(action: PayloadAction<IYearlevel_map>) {
  try {
    const response: AxiosResponse = yield call(EditYearlevel_mapApi, action);
    yield put(successEditYearlevel_map(response.data));
  } catch (error) {
    yield put(failureEditYearlevel_map(error));
  }
}

// delete
const DeleteYearlevel_mapApi = (action: PayloadAction<number>) => {
  return api.delete("/api/category/delete_yeargroup_mapping", {
    params: { id: action.payload },
  });
};

export function* DeleteYearlevel_mapCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteYearlevel_mapApi, action);
    yield put(successdeleteYearlevel_map(response.data));
  } catch (error) {
    yield put(failuredeleteYearlevel_map(error));
  }
}
